import { useCallback } from "react";
import { Actions, useWalletContext } from "../store";
export const useWalletError = () => {
    const { state: { error }, dispatch, } = useWalletContext();
    /**
     * Clears the wallet error.
     */
    const clearError = useCallback(() => Actions.setError(null, dispatch), []);
    return { error, clearError };
};
//# sourceMappingURL=useWalletError.js.map